/* eslint-disable max-len */
import { AnonymousStudentServiceReady, IAnonymousStudentService } from '@studyportals/anonymous-student-interfaces';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import {
	ISessionService,
	IWishlistService,
	SessionServiceReadyEvent,
	WishlistServiceReadyEvent
} from '@studyportals/student-interfaces';
import CIOSubscriber from './CIOSubscriber';
import CIOTracker from './CIOTracker';

declare const CIO_SITE_ID: string;

export default class CIOSetupHandler
	implements ISubscriber<AnonymousStudentServiceReady | SessionServiceReadyEvent | WishlistServiceReadyEvent>
{
	private eventAggregationService = window.EventAggregationService;
	private anonymousStudent?: IAnonymousStudentService;
	private sessionService?: ISessionService;
	private wishlistService?: IWishlistService;

	public init(): void {
		this.initCustomerIOScript();

		if (this.eventAggregationService) {
			this.eventAggregationService.subscribeTo(AnonymousStudentServiceReady.EventType, this, true);
			this.eventAggregationService.subscribeTo(SessionServiceReadyEvent.EventType, this, true);
			this.eventAggregationService.subscribeTo(WishlistServiceReadyEvent.EventType, this, true);
		}
	}

	public notify(event: AnonymousStudentServiceReady | SessionServiceReadyEvent | WishlistServiceReadyEvent): void {
		if (event.eventType === AnonymousStudentServiceReady.EventType) {
			this.anonymousStudent = (event as AnonymousStudentServiceReady).anonymousStudentService;
		}

		if (event.eventType === SessionServiceReadyEvent.EventType) {
			this.sessionService = (event as SessionServiceReadyEvent).sessionService;
		}

		if (event.eventType === WishlistServiceReadyEvent.EventType) {
			this.wishlistService = (event as WishlistServiceReadyEvent).wishlistService;
		}

		if (this.anonymousStudent && this.sessionService && this.wishlistService) {
			const tracker = new CIOTracker(this.anonymousStudent, this.sessionService, this.wishlistService);

			new CIOSubscriber(tracker);
		}
	}

	/* eslint-disable */
	private initCustomerIOScript(): void {
		var _cio: any = _cio || [];
		(function (): void {
			var a, b, c;
			a = function (f: any) {
				return function () {
					_cio.push([f].concat(Array.prototype.slice.call(arguments, 0)));
				};
			};
			b = ['load', 'identify', 'sidentify', 'track', 'page'];
			for (c = 0; c < b.length; c++) {
				_cio[b[c]] = a(b[c]);
			}
			var t = document.createElement('script'),
				s = document.getElementsByTagName('script')[0];
			t.async = false;
			t.id = 'cio-tracker';
			t.setAttribute('data-site-id', CIO_SITE_ID);
			t.setAttribute('data-use-array-params', 'true');
			t.src = 'https://assets.customer.io/assets/track-eu.js';
			s?.parentNode?.insertBefore(t, s);
		})();

		window._cio = _cio;
	}
	/* eslint-enable */
}

new CIOSetupHandler().init();
